import _ from "lodash";

export const toInt = (value) => {
	return _.toInteger(value);
};

export const toNum = (value) => {
	return _.toNumber(value);
};

export const firstCapital = (value) => {
	let values = _.words(value);
	_.forEach(values, (val, i)=> {
		let v = _.toLower(val);
		let u = _.upperFirst(v);
		values[i] = u;
	});
	return _.join(values, ' ');
}

export const allLower = (value) => {
	return _.toLower(value);
}

export const allUpper = value => {
	return _.toUpper(value);
}


// WEBPACK FOOTER //
// ./src/elements/parsers.js